import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva } from "class-variance-authority";

import { cn } from "src/lib/utils";

const buttonVariants = cva(
	"tw-inline-flex tw-items-center tw-h-auto tw-justify-center tw-whitespace-nowrap tw-rounded-md tw-text-[15px] tw-font-medium tw-ring-offset-background tw-transition-colors focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ring focus-visible:tw-ring-offset-2 disabled:tw-pointer-events-none disabled:tw-opacity-50",
	{
		variants: {
			variant: {
				default: "tw-bg-primary tw-text-primary-foreground hover:tw-bg-primary/90",
				destructive: "tw-bg-destructive tw-text-destructive-foreground hover:tw-bg-destructive/90",
				outline: "tw-border tw-text-black tw-border-input tw-bg-background hover:tw-bg-accent hover:tw-text-accent-foreground",
				secondary: "tw-bg-green tw-text-white hover:tw-bg-green/80",
				ghost: "hover:tw-bg-accent tw-text-black hover:tw-text-accent-foreground",
				hover: "hover:tw-bg-accent !tw-px-1 !tw-py-1 tw-rounded-lg [&>svg]:tw-text-black",
				link: "tw-text-primary tw-underline-offset-4 hover:tw-underline",
			},
			size: {
				default: "tw-px-6 tw-py-4",
				sm: "tw-rounded-md tw-px-4 tw-py-2",
				lg: "tw-rounded-md tw-px-8",
				icon: "tw-w-10",
			},
		},
		defaultVariants: {
			variant: "default",
			size: "default",
		},
	}
);

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
	const Comp = asChild ? Slot : "button";
	return <Comp className={cn(buttonVariants({ variant, size, className }))} ref={ref} {...props} />;
});
Button.displayName = "Button";

export { Button, buttonVariants };
